import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Tournament } from '@iziping/common';

interface TournamentStore {
    selectedTournament: Tournament | null;
    selectTournament: (tournament: Tournament) => void;
    deselectTournament: () => void;
}

export const useTournamentStore = create<TournamentStore>()(
    persist(
        (set) => ({
            selectedTournament: null,
            selectTournament: (tournament) => set({ selectedTournament: tournament }),
            deselectTournament: () => set({ selectedTournament: null }),
        }),
        { name: 'tournament-storage' }
    )
);
